// extracted by mini-css-extract-plugin
export default {"thankyou":"Thankyou_thankyou__lacAs","thankyou1":"Thankyou_thankyou1__a+u72","thankyou123":"Thankyou_thankyou123__V2NI4"};